import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import BrandLink from "./BrandLink";
import { Button, QuietPrimaryButton, QuietSecondaryButton, TextLink } from "./ui";

export { QuietPrimaryButton, QuietSecondaryButton, TextLink, Button };
export { TextLink as QuietTextLink };

/** Shared quieter shell for FAQ / Support / For Organizers. */
export default function QuietMarketingLayout({
  title,
  description,
  children,
  heroExtra = null,
  backTo = "/",
  backLabel = "Home",
  backTestId,
  brandTestId,
}) {
  return (
    <div className="min-h-screen bg-canvas text-ink font-body home-landing">
      <section className="home-hero relative overflow-hidden">
        <div className="home-hero-wash absolute inset-0 pointer-events-none" aria-hidden />

        <header className="relative z-10 mx-auto w-full max-w-page lg:max-w-5xl px-4 lg:px-8 pt-5 pb-2 flex items-center justify-between gap-3">
          <Link
            to={backTo}
            className="inline-flex items-center gap-1.5 font-ui font-medium text-[13px] text-white/70 hover:text-white transition-colors min-h-[44px]"
            data-testid={backTestId}
          >
            <ArrowLeft className="w-4 h-4" strokeWidth={2} aria-hidden /> {backLabel}
          </Link>
          <BrandLink
            to="/"
            variant="sticker"
            size="sm"
            testId={brandTestId}
            className="opacity-90"
            wordmarkClassName="font-normal text-[15px] text-white/80"
            aria-label="rsvp.dance home"
          >
            <span className="sr-only">rsvp.dance</span>
          </BrandLink>
        </header>

        <div className="relative mx-auto w-full max-w-page lg:max-w-5xl px-4 lg:px-8 pt-10 pb-14 sm:pt-12 sm:pb-16">
          <div className="home-hero-copy max-w-2xl">
            <h1 className="font-display font-semibold text-[clamp(2rem,7vw,3.25rem)] leading-[1.05] tracking-[-0.02em] text-white text-balance">
              {title}
            </h1>
            {description ? (
              <div className="mt-4 max-w-md text-[15px] font-normal leading-relaxed text-white/80 text-pretty">
                {description}
              </div>
            ) : null}
            {heroExtra}
          </div>
        </div>
      </section>

      <div className="mx-auto w-full max-w-page lg:max-w-5xl px-4 lg:px-8 pt-10 lg:pt-12 pb-16">
        {children}
      </div>
    </div>
  );
}
